import React, { FC } from 'react';

export const SquareCheckIcon: FC<React.PropsWithChildren<{ className?: string }>> = ({
  className = ''
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="check">
        <path
          id="icon/navigation/check_24px"
          d="M5.86339 10.5846L3.08339 7.80458L2.13672 8.74458L5.86339 12.4713L13.8634 4.47125L12.9234 3.53125L5.86339 10.5846Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
